import * as React from 'react';
import { Outlet } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { useQuery } from "graphql-hooks";
import { Loading } from '../components/Shared/Loading';

const CMS_QUERY = `query datoQuery {
  websiteConfiguration {
    fieldWebsiteTitle
    fieldWebsiteLogo {
      alt
      url
      title
      width
      height
    }
  }
}`;

export const PrintLayout = () => {

    const openPrintDialog = () => {
        window.print();
    }
    const { loading, error, data } = useQuery(CMS_QUERY);

    if (!error && !loading) {
        return (
            <>
                <div className="page">
                    <header className="container-fluid header">
                        <Row className="headerContainer printLayout">
                            <Col sm={10}>
                                <div className="logoContainer">
                                    <a href="/" className={'logoLink'}><div className={'logoImage'}><img src={data.websiteConfiguration.fieldWebsiteLogo.url} className="logo" alt={data.websiteConfiguration.fieldWebsiteLogo.alt} /></div>
                                        <div className="headingTitle programName">{data.websiteConfiguration.fieldWebsiteTitle}</div></a>
                                </div>
                            </Col>
                            <Col sm={2} className="text-align-right printButton">
                                <Row>
                                    <Col className="text-align-center">
                                        <Button className="submitButton solidNeg primaryButton iconRightArrow" onClick={openPrintDialog}>Print this page</Button>
                                        <div className="browserMessage">
                                            with Chrome or Edge for best print quality
                                        </div>
                                    </Col>
                                </Row>

                            </Col>
                        </Row>
                    </header>
                    <Outlet />
                </div>
            </>
        )
    } else {
        return (<Loading showContent={false} includeHero={false} />);
    }
};
